import React, {useEffect, useState} from 'react';
import {Button, Card, Col, DatePicker, Input, message, Modal, Radio, Row, Space} from 'antd';
import 'moment/locale/zh-cn';
import locale from 'antd/es/date-picker/locale/zh_CN';
import style from './HomePage.module.less'
import './HomePage.css'
import {getComMsg} from '../../api/HomePage'
import moment from 'moment'
import qs from 'qs'
import {hideLoading, showLoading} from "../../common/Xjkjload"
import QRCode from "qrcode";

const HomePage = () => {
    const {RangePicker} = DatePicker;
    const [useMsg, setUseMsg] = useState({})
    const [useMsgs, setUseMsgs] = useState({})
    const [jinr1, setJine1] = useState(null)
    const [jinr2, setJine2] = useState(0)
    const [jinr3, setJine3] = useState(0)
    const [timeDate, setTimeDate] = useState({})
    const [qrCodeModalVisible, setQrCodeModalVisible] = useState(false);
    const [qrCodeUrl, setQrCodeUrl] = useState('');
    let merchantServeId = window.localStorage.getItem("merchantServeId");
    let isShowRate = window.localStorage.getItem("isShowRate");
    let merchantType = window.localStorage.getItem("merchantType");
    useEffect(() => {
        //  merchantServeId = window.localStorage.getItem("merchantServeId");
        // console.log(merchantServeId)
        if (merchantServeId) {
            let obj = {merchantServeId}
            let newValues = qs.stringify(obj)
            getComMsg(newValues).then(res => {
                if (res.data.data) {
                    setUseMsg(res.data.data)
                    setUseMsgs(res.data.data)
                }
            })
        }
    }, [merchantServeId])
    const setInput = (e) => {
        setJine1(e.target.value)
    }
    const setValue = () => {
        if (jinr1 == null) {
            message.warn('请输入结算金额')
        } else {
            if (jinr1 * 1 < 0) {
                message.warn('结算金额不能为负数')
            } else {
                let feiLv = useMsg.serviceRate
                feiLv = feiLv.replace("%", "") / 100;
                let num1 = jinr1 * feiLv
                let roundedNumber = Math.round(num1 * Math.pow(10, 2)) / Math.pow(10, 2)
                setJine3(roundedNumber)
                let num2 = num1 + jinr1 * 1
                let roundedNumber2 = Math.round(num2 * Math.pow(10, 2)) / Math.pow(10, 2)
                setJine2(roundedNumber2)
            }
        }
    }
    const setTime = (data, dateString) => {
        // let merchantServeId = window.localStorage.getItem("merchantServeId");
        let startTime = dateString[0]
        let endTime = dateString[1]
        let obj = {merchantServeId, startTime, endTime}
        setTimeDate(obj)
    }
    const onBty = () => {
        if (JSON.stringify(timeDate) === '{}') {
            // let merchantServeId = window.localStorage.getItem("merchantServeId");
            let obj = {merchantServeId}
            let newValues = qs.stringify(obj)
            showLoading()
            getComMsg(newValues).then(res => {
                hideLoading()
                if (res.data.data) {
                    setUseMsg(res.data.data)
                }
            })
        } else {
            let newValues = qs.stringify(timeDate)
            showLoading()
            getComMsg(newValues).then(res => {
                hideLoading()
                if (res.data.data) {
                    setUseMsg(res.data.data)
                }
            })
        }
    }
    const onJinRi = () => {
        // let merchantServeId = window.localStorage.getItem("merchantServeId");
        let startTime = moment().format('YYYY-MM-DD')
        let endTime = moment().format('YYYY-MM-DD')
        let obj = {merchantServeId, startTime, endTime}
        let newValues = qs.stringify(obj)
        showLoading()
        getComMsg(newValues).then(res => {
            hideLoading()
            if (res.data.data) {
                setUseMsg(res.data.data)
            }
        })

    }
    const onBenYue = () => {
        // let merchantServeId = window.localStorage.getItem("merchantServeId");
        let startTime = moment().startOf('month').format('YYYY-MM-DD')
        let endTime = moment().format('YYYY-MM-DD')
        let obj = {merchantServeId, startTime, endTime}
        let newValues = qs.stringify(obj)
        showLoading()
        getComMsg(newValues).then(res => {
            hideLoading()
            if (res.data.data) {
                setUseMsg(res.data.data)
            }
        })
    }
    const onQuanBu = () => {
        // let merchantServeId = window.localStorage.getItem("merchantServeId");
        let obj = {merchantServeId}
        let newValues = qs.stringify(obj)
        showLoading()
        getComMsg(newValues).then(res => {
            hideLoading()
            if (res.data.data) {
                setUseMsg(res.data.data)
            }
        })
    }

    // 下载模板
    const getXlsx = () => {
        let url = 'https://www.027xjkj.com/自由职业者签约及结算模板.xlsx'
        window.location.href = url
    }

    const getTalentXlsx = () => {
        const w = window.open('_black')
        let url = 'https://www.027xjkj.com/自由职业者签约及结算模板.xlsx'
        w.location.href = url
    }

    const openPreviewDialog = () => {
        // 这里假设需要生成二维码的URL是签约页面的URL
        // const contractUrl = `https://sign.027xjkj.com/admin/H5sign/h5?pr_id=2600&cu_id=138&sign_type=4&task_id=3283&s_id=2&customer_name=%E6%9D%AD%E5%B7%9E%E7%81%B5%E5%85%94%E4%BF%A1%E6%81%AF%E6%8A%80%E6%9C%AF%E6%9C%8D%E5%8A%A1%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8&a_id=81&acc_type=1#/TaskView`;
        if(!useMsg.signH5Url){
            message.warn('签约链接为空')
            return
        }
        const contractUrl = useMsg.signH5Url;

        // 使用纯前端函数生成二维码
        QRCode.toDataURL(contractUrl, {width: 300}, (err, url) => {
            if (err) return message.error(err);
            setQrCodeUrl(url);
            setQrCodeModalVisible(true);
        });
    }

    const getGuideXlsx = () => {
        const w = window.open('_black')
        let url = 'https://www.027xjkj.com/系统操作指南.pdf'
        w.location.href = url
    }
    return (<div className={style.HomePage}>

            {
                (<div className={style.HomePage_header}>
                    <Row>
                        <Col className="searchTime">
                            <Space direction="vertical" size={12}>
                                <RangePicker locale={locale} onChange={setTime}/>
                            </Space>
                            <Button type="primary" style={{marginLeft: "15px"}} onClick={onBty}>查询</Button>
                        </Col>
                        <Col className="searchButton">
                            <Radio.Group style={{marginLeft: "20px"}} defaultValue="c" buttonStyle="solid">
                                <Radio.Button value="a" onClick={onJinRi}>今日</Radio.Button>
                                <Radio.Button value="b" onClick={onBenYue}>本月</Radio.Button>
                                <Radio.Button value="c" onClick={onQuanBu}>全部</Radio.Button>
                            </Radio.Group>
                        </Col>
                    </Row>
                </div>)
            }
            <div className={style.HomePage_context}>
                <Row gutter={16}>
                    <Col span={6}>
                        <Card
                            title={useMsg.merchantType === 'lingtu' ? (useMsg.isContainFee === 0 ? '账户余额(可实发金额):' : '账户余额(含服务费金额):') : '账户余额:'}
                            bordered={false} style={{background: "#f7f8fa"}}>
                            {useMsg.accountBalance}
                        </Card>
                    </Col>
                    <Col span={6}>
                        <Card title="下发金额" bordered={false} style={{background: "#f7f8fa"}}>
                            {useMsg.paymentAmount}
                        </Card>
                    </Col>
                    {
                        isShowRate == "1" ?
                            <Col span={6}> <Card title="服务费" bordered={false} style={{background: "#f7f8fa"}}>
                                {useMsg.serviceCharge}
                            </Card></Col> : <div/>
                    }
                    {
                        isShowRate == "1" ?
                            <Col span={6}> <Card title="充值金额" bordered={false} style={{background: "#f7f8fa"}}>
                                {useMsg.rechargeAmount}
                            </Card></Col> : <div/>
                    }
                </Row>
            </div>
            <div className={style.HomePage_calculator}>
                {/*<Row>*/}
                {/*    <Col span={4} className={style.HomePage_titles}>充值计算器</Col>*/}
                {/*    <Col span={6} offset={12}><Input placeholder="请输入结算金额" size="large" onChange={setInput}/></Col>*/}
                {/*    <Col span={2}><Button size="large" className={style.HomePage_bty} block="true"*/}
                {/*                          onClick={setValue}>计算</Button></Col>*/}
                {/*</Row>*/}
            </div>
            <div className={style.HomePage_footer}>
                <div className={style.HomePage_footer_left}>
                    <div className={style.HomePage_footer_left_row}>
                        {/* 人才签约模版 */}
                        <div
                            alt="人才签约模版"
                            className={style.HomePage_footer_talent_icon}
                        />
                        <div className={style.HomePage_footer_settlement_content}>
                            <div
                                className={style.HomePage_footer_settlement_title}>{merchantType === 'lingtu' ? '签约二维码' : '签约模版'}</div>
                            <div
                                className={style.HomePage_footer_settlement_description}>{merchantType === 'lingtu' ? '点击预览打开人才签约二维码' : '点击下载即可下载人才签约模版'}
                            </div>
                        </div>
                        <button className={style.HomePage_footer_download_button}
                                onClick={merchantType === 'lingtu' ? openPreviewDialog : getTalentXlsx}>{merchantType === 'lingtu' ? '去预览' : '去下载'}</button>
                    </div>

                    <div className={style.HomePage_footer_left_row}>
                        {/* 结算单模板 */}
                        <div
                            alt="结算单模板"
                            className={style.HomePage_footer_settlement_icon}
                        />
                        <div className={style.HomePage_footer_settlement_content}>
                            <div className={style.HomePage_footer_settlement_title}>结算单模版</div>
                            <div className={style.HomePage_footer_settlement_description}>点击下载即可下载结算单模版
                            </div>
                        </div>
                        <button className={style.HomePage_footer_download_button} onClick={getXlsx}>去下载</button>
                    </div>

                    <div className={style.HomePage_footer_left_row}>
                        {/* 系统操作指南 */}
                        <div
                            alt="系统操作指南"
                            className={style.HomePage_footer_guide_icon}
                        />
                        <div className={style.HomePage_footer_settlement_content}>
                            <div className={style.HomePage_footer_settlement_title}>系统操作指南</div>
                            <div className={style.HomePage_footer_settlement_description}>点击即可下载《系统操作指南》
                            </div>
                        </div>
                        <button className={style.HomePage_footer_download_button} onClick={getGuideXlsx}>去下载</button>
                    </div>


                </div>
                <div className={style.HomePage_footer_right2}>
                    <div className={style.HomePage_footer_left_P}>
                        服务费率：
                    </div>
                    <div className={style.HomePage_footer_left_P1}>
                        {useMsgs.serviceRate}
                    </div>
                    <div className={style.HomePage_footer_left_P2}>
                        打款户名：<span style={{color: "#67757c"}}>{useMsgs.paymentAccountName}</span>
                    </div>
                    <div className={style.HomePage_footer_left_P2}>
                        打款账户：<span style={{color: "#67757c"}}>{useMsgs.paymentAccount}</span>
                    </div>
                    <div className={style.HomePage_footer_left_P2}>
                        开户行：<span style={{color: "#67757c"}}>{useMsgs.accountBank}</span>
                    </div>

                    {
                        useMsg.isAlipay == "1" ?
                            (<div>
                                    <div className={style.HomePage_footer_left_P2}>
                                        支行：<span style={{color: "#67757c"}}>{useMsgs.cardBranch}</span>
                                    </div>
                                    <div className={style.HomePage_footer_left_P2}>
                                        联行号：<span style={{color: "#67757c"}}>{useMsgs.cardDeposit}</span>
                                    </div>
                                    <div className={style.HomePage_footer_left_P2}>
                                        开户地址：<span style={{color: "#67757c"}}>{useMsgs.cardLocation}</span>
                                    </div>
                                </div>
                            )
                            : ""
                    }

                </div>
            </div>

            {/* 二维码弹窗 */}
            <Modal
                visible={qrCodeModalVisible}
                title="人才签约二维码"
                open={qrCodeModalVisible}
                onCancel={() => setQrCodeModalVisible(false)}
                footer={[
                    <Button key="close" onClick={() => setQrCodeModalVisible(false)}>
                        关闭
                    </Button>
                ]}
                width={350}
            >
                <div style={{textAlign: 'center', padding: '20px 0'}}>
                    <img
                        src={qrCodeUrl}
                        alt="签约二维码"
                        style={{maxWidth: '100%', height: 'auto'}}
                    />
                    <p style={{marginTop: '15px', color: '#666'}}>扫码打开签约页面</p>
                </div>
            </Modal>

        </div>
    );
}

export default HomePage;
